// extracted by mini-css-extract-plugin
module.exports = {"venue":"_cdf413d","wrapper":"_9bd8994","cardHeader":"_7728982","cardContent":"_5ea0278","cardFooter":"_bdd1119","tabsWrapper":"_b1aea14"};